<template>
  <md-card-content>
    <!-- 法⼈名、支店名 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100 md-form-title"><label>法⼈名</label>
      </div>
      <div class="md-layout-item">
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <div class="md-layout">
              <div class="md-layout-item">
                <md-field :class="getValidationClass('corporation.name')">
                  <label>法⼈名</label>
                  <md-input v-model="form.corporation.name" :disabled="!activated || sending" required></md-input>
                  <span class="md-helper-text">例) 株式会社JON</span>
                  <span class="md-error" v-if="getValidationResponseMessage('corporation.name')">
                    {{ getValidationResponseMessage('corporation.name') }}
                  </span>
                  <span class="md-error" v-else-if="!$v.form.corporation.name.required">
                    {{ errors.corporation.name.required }}
                  </span>
                </md-field>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item">
              <span class="md-caption">
                ※法人名は省略せずにご入力ください。×(株)　〇株式会社<br>
                ※個人のお客様はお手数ですが、法人名、ご担当者名ともお名前をご入力ください。
              </span>
              </div>
            </div>
          </div>
          <div class="md-layout-item">
            <div class="md-layout">
              <div class="md-layout-item">
                <md-field :class="getValidationClass('corporation.branch_name', 'branch_name')">
                  <label>支店名</label>
                  <md-input v-model="form.corporation.branch_name" :disabled="!activated || sending"></md-input>
                  <span class="md-helper-text">例) 上野オフィス、上野支店</span>
                  <span class="md-error" v-if="getValidationResponseMessage('corporation.branch_name')">
                    {{ getValidationResponseMessage('corporation.branch_name') }}
                  </span>
                </md-field>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item">
              <span class="md-caption">
                ※支店名等がある場合は、必ずご入力ください。
              </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 所在地 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100 md-form-title"><label>所在地</label>
      </div>
      <div class="md-layout-item md-size-25 md-small-size-100">
        <md-field :class="getValidationClass('corporation.postal')">
          <label>郵便番号</label>
          <span class="md-prefix">〒</span>
          <md-input v-model="form.corporation.postal" :disabled="!activated || sending" required></md-input>
          <span class="md-helper-text">例) 1076231、"ハイフン不要</span>
          <span class="md-error" v-if="getValidationResponseMessage('corporation.postal')">
            {{ getValidationResponseMessage('corporation.postal') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.postal.required">
            {{ errors.corporation.postal.required }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.postal.numeric">
            {{ errors.corporation.postal.numeric }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.postal.minLength">
            {{ errors.corporation.postal.minLength }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.postal.maxLength">
            {{ errors.corporation.postal.maxLength }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-25 md-small-size-50">
        <md-field :class="getValidationClass('corporation.pref')">
          <label>都道府県</label>
          <md-select v-model="form.corporation.pref" id="citySelected" :disabled="!activated || sending" required>
            <md-option v-for="(prefecture,index) in prefectures" :value="prefecture" :key="index">
              {{ prefecture }}
            </md-option>
          </md-select>
          <span class="md-helper-text">例) 東京都</span>
          <span class="md-error" v-if="getValidationResponseMessage('corporation.pref')">
            {{ getValidationResponseMessage('corporation.pref') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.pref.required">
            {{ errors.corporation.pref.required }}
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-35 md-small-size-50">
        <md-field :class="getValidationClass('corporation.city')">
          <label>市区町村</label>
          <md-input v-model="form.corporation.city" type="text" :disabled="!activated || sending" required></md-input>
          <span class="md-helper-text">例) 新宿区</span>
          <span class="md-error" v-if="getValidationResponseMessage('corporation.city')">
            {{ getValidationResponseMessage('corporation.city') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.city.required">
            {{ errors.corporation.city.required }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field :class="getValidationClass('corporation.street_name')">
          <label>町名</label>
          <md-input v-model="form.corporation.street_name" :disabled="!activated || sending" required></md-input>
          <span class="md-helper-text">例) 新小川町</span>
          <span class="md-error" v-if="getValidationResponseMessage('corporation.street_name')">
            {{ getValidationResponseMessage('corporation.street_name') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.street_name.required">
            {{ errors.corporation.street_name.required }}
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field :class="getValidationClass('corporation.street_number')">
          <label>番地</label>
          <md-input v-model="form.corporation.street_number" :disabled="!activated || sending" required></md-input>
          <span class="md-helper-text">例) 5-1</span>
          <span class="md-error" v-if="getValidationResponseMessage('corporation.street_number')">
            {{ getValidationResponseMessage('corporation.street_number') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.corporation.street_number.required">
            {{ errors.corporation.street_number.required }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-60 md-small-size-100">
        <md-field :class="getValidationClass('corporation.etc')">
          <label>建物名・部屋番号等</label>
          <md-input v-model="form.corporation.etc" :disabled="!activated || sending"></md-input>
          <span class="md-helper-text">例) ニューリバー51 4F</span>
        </md-field>
      </div>
    </div>

    <!-- ご担当者名 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100"><label>ご担当者名</label>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-50">
        <md-field :class="getValidationClass('account.name_last')">
          <label>姓</label>
          <md-input v-model="form.account.name_last" :disabled="!activated || sending" required></md-input>
          <span class="md-helper-text">例) JON</span>
          <span class="md-error" v-if="getValidationResponseMessage('account.name_last')">
            {{ getValidationResponseMessage('account.name_last') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.account.name_last.required">
            {{ errors.account.name_last.required }}
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-50">
        <md-field :class="getValidationClass('account.name_first')">
          <label>名</label>
          <md-input v-model="form.account.name_first" :disabled="!activated || sending" required></md-input>
          <span class="md-helper-text">例) 太郎</span>
          <span class="md-error" v-if="getValidationResponseMessage('account.name_first')">
            {{ getValidationResponseMessage('account.name_first') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.account.name_first.required">
            {{ errors.account.name_first.required }}
          </span>
        </md-field>
      </div>
    </div>

    <!-- ご連絡先 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100"><label>ご連絡先</label>
      </div>
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field :class="getValidationClass('account.email')">
              <label>メールアドレス</label>
              <md-input v-model="form.account.email" name="mail" required placeholder="例）jontaro@jon.co.jp"
                        :disabled="true"/>
              <span class="md-helper-text">例) jontaro@jon.co.jp</span>
              <span class="md-error" v-if="getValidationResponseMessage('account.email')">
                {{ getValidationResponseMessage('account.email') }}
              </span>
              <span class="md-error"
                    v-else-if="!$v.form.account.email.required">
                {{ errors.account.email.required }}
              </span>
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item">
            <span class="md-caption">※メールアドレスは本契約後に変更が可能です。</span>
          </div>
        </div>
      </div>
      <div class="md-layout-item">
        <md-field :class="getValidationClass('account.tel')">
          <label>電話番号</label>
          <md-input v-model="form.account.tel" :disabled="!activated || sending" name="phone" required/>
          <span class="md-helper-text">例) 0332691220</span>
          <span class="md-error" v-if="getValidationResponseMessage('account.tel')">
            {{ getValidationResponseMessage('account.tel') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.account.tel.required">
            {{ errors.account.tel.required }}
          </span>
          <span class="md-error" v-else-if="!$v.form.account.tel.numeric">
            {{ errors.account.tel.numeric }}
          </span>
        </md-field>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import Common                                           from "../../modules/common";
import CommonMixin                                      from "../../mixins/commonMixin";
import ContractFormMixin                                from "../../mixins/contractFormMixin";
import Validation                                       from "../../modules/validation";
import {validationMixin}                                from "vuelidate";
import {email, maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import YubinBango                                       from "../../modules/yubinbango";

export default {
  name  : 'ContractFormApply',
  mixins: [CommonMixin, ContractFormMixin, validationMixin],
  props : ['value', 'activated'],
  data  : () => ({
    prefectures: Common.prefectures,
    form       : {
      corporation: {
        name         : null,
        branch_name  : null,
        postal       : null,
        pref         : null,
        city         : null,
        street_name  : null,
        street_number: null,
      },
      account    : {
        name_last : '',
        name_first: '',
        email     : null,
        tel       : null,
      },
    },
    errors     : {
      corporation: {
        name         : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationName'),
        },
        postal       : {
          required : Validation.errorMessage(Validation.rules.required, 'corporationPostal'),
          maxLength: Validation.errorMessage(Validation.rules.size, 'corporationPostal', 7),
          minLength: Validation.errorMessage(Validation.rules.size, 'corporationPostal', 7),
          numeric  : Validation.errorMessage(Validation.rules.numeric, 'corporationPostal'),
        },
        pref         : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationAddressPref'),
        },
        city         : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationAddressCity'),
        },
        street_name  : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationStreetName'),
        },
        street_number: {
          required: Validation.errorMessage(Validation.rules.required, 'corporationStreetNumber'),
        },
      },
      account    : {
        name_last : {
          required: Validation.errorMessage(Validation.rules.required, 'accountLastName'),
        },
        name_first: {
          required: Validation.errorMessage(Validation.rules.required, 'accountFirstName'),
        },
        email     : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationEmail'),
          email,
        },
        tel       : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationTel'),
          numeric : Validation.errorMessage(Validation.rules.numeric, 'corporationTel'),
        },
      },
    },
  }),
  validations() {
    return {
      form: {
        corporation: {
          name         : {
            required,
          },
          postal       : {
            required,
            numeric,
            maxLength: maxLength(7),
            minLength: minLength(7),
          },
          pref         : {
            required,
          },
          city         : {
            required,
          },
          street_name  : {
            required,
          },
          street_number: {
            required,
          },
        },
        account    : {
          name_last : {
            required,
          },
          name_first: {
            required,
          },
          email     : {
            required,
            email,
          },
          tel       : {
            numeric,
            required,
          },
        },
      }
    }
  },
  methods: {
    changeCorporationInformation() {
      this.$emit('input', this.form);
      this.$emit('changeCorporationInfo');
    },
  },
  watch  : {
    "form.corporation.postal": function (pCode) {
      if (!pCode) {
        this.form.corporation.postal = '';
        this.changeCorporationInformation();
        return false;
      }

      const field = this.$v.form.corporation['postal'];
      if (field.$invalid === true && field.$dirty === true) {
        return;
      }
      let _this = this;
      new YubinBango.Core(pCode, function (addr) {
        if (addr.region.length === 0) {
          return;
        }
        if ((_this.form.corporation.city !== null && _this.form.corporation.city !== '')
            || (_this.form.corporation.street_name !== null && _this.form.corporation.street_name !== ''
            )) {
          return;
        }
        _this.form.corporation.pref        = addr.region;
        _this.form.corporation.city        = addr.locality;
        _this.form.corporation.street_name = addr.street;
      });

      this.form.corporation.postal = pCode.match(/\d/ig) ? pCode.match(/\d/ig).join('') : '';
    },
    "form.corporation.pref"  : function () {
      this.changeCorporationInformation();
    },
    "form.corporation.city"  : function () {
      this.changeCorporationInformation();
    },
    "form.corporation.town"  : function () {
      this.changeCorporationInformation();
    },
    "form.corporation.etc"   : function () {
      this.changeCorporationInformation();
    },
    "form.corporation.email" : function () {
      this.changeCorporationInformation();
    },
  },
}
</script>

<style lang="scss" scoped>
.md-form-title {
  align-items: baseline;
  margin-top: 28px;
}
</style>
